import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "sonner";
import useQrTracking from "./hooks/useQrTracking";

import PublicLayout from "./components/PublicLayout";
import AdminLayout from "./components/AdminLayout";

import Home from "./pages/public/Home";
import Carta from "./pages/public/Carta";
import Horarios from "./pages/public/Horarios";
import Programa from "./pages/public/Programa";
import Ubicacion from "./pages/public/Ubicacion";
import Convivencia from "./pages/public/Convivencia";
import Sugerencias from "./pages/public/Sugerencias";
import Afiliacion from "./pages/public/Afiliacion";
import Avisos from "./pages/public/Avisos";
import GaleriaVisitantes from "./pages/public/GaleriaVisitantes";
import Pantalla from "./pages/public/Pantalla";
import Fichar from "./pages/public/Fichar";
import CeliaRedirect from "./pages/public/CeliaRedirect";

import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import AdminContenido from "./pages/admin/AdminContenido";
import AdminCarta from "./pages/admin/AdminCarta";
import AdminPrograma from "./pages/admin/AdminPrograma";
import AdminAvisos from "./pages/admin/AdminAvisos";
import AdminSugerencias from "./pages/admin/AdminSugerencias";
import AdminMensajes from "./pages/admin/AdminMensajes";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminMedia from "./pages/admin/AdminMedia";
import AdminPerfil from "./pages/admin/AdminPerfil";
import AdminGaleriaVisitantes from "./pages/admin/AdminGaleriaVisitantes";
import AdminPantallas from "./pages/admin/AdminPantallas";
import AdminControlHorario from "./pages/admin/AdminControlHorario";

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-muted-foreground">Cargando…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function Tracker() {
  useQrTracking();
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <Tracker />
          <Routes>
            <Route path="/pantalla" element={<Pantalla />} />
            <Route path="/fichar" element={<Fichar />} />
            <Route path="/celia" element={<CeliaRedirect />} />

            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/carta" element={<Carta />} />
              <Route path="/horarios" element={<Horarios />} />
              <Route path="/programa" element={<Programa />} />
              <Route path="/ubicacion" element={<Ubicacion />} />
              <Route path="/convivencia" element={<Convivencia />} />
              <Route path="/sugerencias" element={<Sugerencias />} />
              <Route path="/afiliacion" element={<Afiliacion />} />
              <Route path="/avisos" element={<Avisos />} />
              <Route path="/galeria" element={<GaleriaVisitantes />} />
            </Route>

            <Route path="/admin/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <RequireAuth>
                  <AdminLayout />
                </RequireAuth>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="contenido" element={<AdminContenido />} />
              <Route path="carta" element={<AdminCarta />} />
              <Route path="programa" element={<AdminPrograma />} />
              <Route path="avisos" element={<AdminAvisos />} />
              <Route path="sugerencias" element={<AdminSugerencias />} />
              <Route path="mensajes" element={<AdminMensajes />} />
              <Route path="analytics" element={<AdminAnalytics />} />
              <Route path="media" element={<AdminMedia />} />
              <Route path="galeria-visitantes" element={<AdminGaleriaVisitantes />} />
              <Route path="pantallas" element={<AdminPantallas />} />
              <Route path="control-horario" element={<AdminControlHorario />} />
              <Route path="perfil" element={<AdminPerfil />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
